"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobileView = _interopRequireDefault(require("../../view/MobileView"));

var _DesktopTabletView = _interopRequireDefault(require("../../view/DesktopTabletView"));

var _Icon = _interopRequireDefault(require("../../icons/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DesktopHolder = _styledComponents["default"].div.attrs(function (props) {
  return {
    className: "d-flex justify-content-" + props.justifyContent
  };
}).withConfig({
  displayName: "StickyFooterButtons__DesktopHolder",
  componentId: "sc-17iivt2-0"
})(["button:not(:last-child){margin-right:0.625rem;}"]);

var MobileHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "fixed-bottom"
  };
}).withConfig({
  displayName: "StickyFooterButtons__MobileHolder",
  componentId: "sc-17iivt2-1"
})(["&&&{box-shadow:0 -4px 1.25rem 0 rgba(0,0,0,0.2);background:", ";button:not(:last-child){margin-bottom:0.625rem;}}"], function (props) {
  return props.styles.background;
});

var Data = _styledComponents["default"].div.attrs(function () {
  return {
    className: "card card-body"
  };
}).withConfig({
  displayName: "StickyFooterButtons__Data",
  componentId: "sc-17iivt2-2"
})(["&&&{background:", ";}"], function (props) {
  return props.styles.background;
});

var IconHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex justify-content-center align-items-center"
  };
}).withConfig({
  displayName: "StickyFooterButtons__IconHolder",
  componentId: "sc-17iivt2-3"
})(["width:100%;height:38px;text-align:center;"]);

var Collapse = _styledComponents["default"].div.attrs(function (props) {
  return {
    "data-toggle": "collapse",
    href: "#stickFooterButtons",
    "aria-expanded": props.startsOpen,
    "aria-controls": "stickFooterButtons"
  };
}).withConfig({
  displayName: "StickyFooterButtons__Collapse",
  componentId: "sc-17iivt2-4"
})([""]);

var CollapseData = _styledComponents["default"].div.attrs(function (props) {
  return {
    className: "collapse " + (props.startsOpen ? "show" : ""),
    id: "stickFooterButtons"
  };
}).withConfig({
  displayName: "StickyFooterButtons__CollapseData",
  componentId: "sc-17iivt2-5"
})([""]);

var StickyFooterButtons = function StickyFooterButtons(_ref) {
  var children = _ref.children,
      justifyContent = _ref.justifyContent,
      styles = _ref.styles,
      _ref$startsOpen = _ref.startsOpen,
      startsOpen = _ref$startsOpen === void 0 ? true : _ref$startsOpen;

  var _useState = (0, _react.useState)(startsOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    background: Theme["white"]
  };

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  var toggleOpen = function toggleOpen() {
    setIsOpen(!isOpen);
  };

  return _react["default"].createElement("div", {
    id: "sticky-footer-buttons"
  }, _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(MobileHolder, {
    styles: CompStyles
  }, _react["default"].createElement(IconHolder, null, _react["default"].createElement(Collapse, {
    onClick: toggleOpen,
    startsOpen: startsOpen
  }, isOpen ? _react["default"].createElement(_Icon["default"], {
    iconName: "fa-chevron-down",
    className: "fa-lg"
  }) : _react["default"].createElement(_Icon["default"], {
    iconName: "fa-chevron-up",
    className: "fa-lg"
  }))), _react["default"].createElement(CollapseData, {
    startsOpen: startsOpen
  }, _react["default"].createElement(Data, {
    className: "card card-body",
    styles: CompStyles
  }, children)))), _react["default"].createElement(_DesktopTabletView["default"], null, _react["default"].createElement(DesktopHolder, {
    justifyContent: justifyContent
  }, children)));
};

StickyFooterButtons.defaultProps = {
  justifyContent: "end",
  styles: {},
  startsOpen: true
};
StickyFooterButtons.propTypes = {
  /** how to justify the content on desktop */
  justifyContent: _propTypes["default"].string,

  /** styles to apply to the buttons */
  styles: _propTypes["default"].shape({
    background: _propTypes["default"].string
  }),

  /** children of the buttons to display */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,

  /** if the footer buttons should start open */
  startsOpen: _propTypes["default"].bool
};
var _default = StickyFooterButtons;
exports["default"] = _default;